// @flow

type Record<K, V> = { [key: string]: V };

/************************************************************************************/
/* WARNING: This file is generated automatically. Don't edit it by hand             */
/************************************************************************************/

import * as api from "./restApi.js";
import * as t from "./kg.generated.types.js";

function enc(s: any): string { return encodeURIComponent("" + s); }

export interface IKg {
    /** Perform simple search in knowledge-graph */
    searchSimple(req: t.ISearchSimpleReq): Promise<t.ISearchSimpleRes>;

    /** Trigger knowledge-graph refresh */
    refreshKnowledgeGraph(req: t.IRefreshKnowledgeGraphReq): Promise<t.IRefreshKnowledgeGraphRes>;

}

export class Kg implements IKg {

    client: api.ApiClient;

    constructor(client: api.ApiClient) { this.client = client; }

    /** Perform simple search in knowledge-graph */
    async searchSimple(req: t.ISearchSimpleReq): Promise<t.ISearchSimpleRes> {
        const reqx: any = req;
        const url = `/api/v1.0/kg/search-simple`;
        return (await this.client.post(url, reqx)).data;
    }

    /** Trigger knowledge-graph refresh */
    async refreshKnowledgeGraph(req: t.IRefreshKnowledgeGraphReq): Promise<t.IRefreshKnowledgeGraphRes> {
        const reqx: any = req;
        const url = `/api/v1.0/kg/refresh`;
        return (await this.client.post(url, reqx)).data;
    }

}
